import {
  ListExpiredPositionRequest,
  ProcessExpiredPositionRequest,
  OccExpiredPositionServiceClient,
  UpdateExpiredPositionRequest,
} from '../proto/occpb/expired_position_grpc_web_pb';
import { stringToProtoDate } from './ConvertService';
import authSvc from './AuthService';
import { auth } from '../lib/auth/Auth';

const userId = authSvc.getCurrentUser()?.UserId;
const service = new OccExpiredPositionServiceClient(
  window.env.GRPC_ENDPOINT,
  {},
  { ...auth }
);

export async function listExpiredPositionOption(param) {
  return new Promise((resolve, reject) => {
    let req = new ListExpiredPositionRequest();
    req.setFromDate(stringToProtoDate(param.fromDate));
    req.setToDate(stringToProtoDate(param.toDate));
    req.setCorrespondent(param.correspondent);
    req.setAccountNo(param.accountNo);
    req.setSymbol(param.symbol);
    req.setUsrId(userId);

    service.listExpiredPosition(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function processExpiredPositionOption(param) {
  return new Promise((resolve, reject) => {
    let req = new ProcessExpiredPositionRequest();

    req.setExpiredPositionIdList(param.positions);

    service.processExpiredPosition(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateExpiredPosition(param) {
  return new Promise((resolve, reject) => {
    let req = new UpdateExpiredPositionRequest();
    req.setExpiredPositionId(param.expiredPositionId);
    req.setExpirationDate(stringToProtoDate(param.expirationDate));
    req.setEntryType(param.entryType);
    req.setQty(param.qty);
    if (param.doNotExercise) {
      req.setDoNotExercise(1);
    } else {
      req.setDoNotExercise(0);
    }
    service.updateExpiredPosition(req, {}, (error, response) => {
      if (error) {
        console.log(error.message);
        reject(error);
      } else {
        console.log(response);
        resolve(response.toObject());
      }
    });
  });
}
